<template>
    <div class="form-sales-land-modal" v-if="form != null">
        <button class="btn-close-form-modal" @click="closeFormModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <div class="form-titles" v-if="formVisible">
            <div class="form-bg" :style="'background-image: url(' + form.form_drop_modal.form_img + ')'"></div>
            <div class="titles">
                <h3>{{form.form_drop_modal.form_title}}</h3>
                <span>{{form.form_drop_modal.form_title_desc}}</span>
            </div>
        </div>
        <div class="form-modal-container">
            <form class="form_call-modal">
                <div class="form-in" v-if="formVisible">
                    <div class="form-group form-text">
                        <input type="text" name="name" class="form-control" :placeholder="form.inputname" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                        <span class="error-message" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>
                    <div class="form-group form-phone">
                        <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.inputphone" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                        <span class="error-message" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                    </div>
                    <VueRecaptcha
                        ref="recaptchaFormLand"
                        @verify="onCaptchaVerified"
                        :sitekey="Gcap_siteKey"
                        size="invisible"
                    />
                    <div class="btn-send">
                        <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.btn_name}}</button>
                    </div>
                </div>
                <div class="successMessage" v-if="!formVisible">
                    <h3>{{form.form_success_msg}}</h3>
                </div>
            </form>
            <div class="privacy-desc" v-if="formVisible">
                <p>
                    <span>{{ form.form_privacy_desc.one }}</span> 
                    «<span>{{ form.btn_name }}</span>»
                    <span class="two">{{ form.form_privacy_desc.two }}</span>
                    <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{form.form_privacy_desc.word }}</a></span>
                    <span class="three">{{ form.form_privacy_desc.three }}</span>
                </p>
            </div>
            <div class="to-many-requests-msg" v-if="toManySendingMsg">
                <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import cookie from 'vue-cookie'
    import {mapGetters} from 'vuex'
    import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        name: 'FormConsultLandModal',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadFormData',
            Gcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('monacoForm_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('monacoForm_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'name': this.name,
                    'phone': this.phone,
                    'project' : 'Monaco',
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('monacoForm_submissionCounter', submissionCounter);
                    localStorage.setItem('monacoForm_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'});
                    setTimeout(() => {
                        this.closeFormModal();
                    }, 300);
                    $.ajax({
                        url: "https://docs.google.com/forms/d/e/1FAIpQLSdpDpLS79J8RRUbqKyoGI-c_ZgqpwQJNeIK2Hnd305otnLDUg/formResponse",
                        data: {
                            // name
                            "entry.1204562308": this.name,
                            // phone
                            "entry.1780907537": this.phone,
                        },
                        type: "POST",
                        dataType: "xml"
                    });
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptchaFormLand.execute();
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            closeFormModal() {
                cookie.set('monaco_form_land_modal_timer', true, { expires: this.form.form_drop_modal.minutes + 'm' });
                this.$store.commit('Open_FormLandModal', false);
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-land-modal.scss';
</style>